import React, { useState, useEffect } from 'react'
import CarouselArrowButton from './CarouselArrowButton'
import CarouselCard from './CarouselCard'
import CarouselDots from './CarouselDots'

import {
  DUMMY_SLIDES
} from './TipsPreview'

const FeatureCarousel: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [direction, setDirection] = useState<'left' | 'right'>('right')

  const handleGoNext = () => {
    setDirection('right')
    setCurrentIndex(function nextIndex(prev) {
      return (prev + 1) % DUMMY_SLIDES.length
    })
  }

  const handleGoPrev = () => {
    setDirection('left')
    setCurrentIndex(function prevIndex(prev) {
      return (prev - 1 + DUMMY_SLIDES.length) % DUMMY_SLIDES.length
    })
  }

  const handleDotClick = (index: number) => {
    setDirection(index > currentIndex ? 'right' : 'left')
    setCurrentIndex(index)
  }

  useEffect(function autoAdvance() {
    const timer = setInterval(function advanceSlide() {
      setDirection('right')
      setCurrentIndex(function nextIndex(prev) {
        return (prev + 1) % DUMMY_SLIDES.length
      })
    }, 6000)
    return function cleanup() {
      clearInterval(timer)
    }
  }, [])

  const currentSlide = DUMMY_SLIDES[currentIndex]

  return (
    <div className="TipsPreview__carousel">
      <div className="TipsPreview__carousel-inner">
        <CarouselArrowButton side="left" onClick={handleGoPrev} />
        <div className="TipsPreview__carousel-card-wrapper">
          <CarouselCard slide={currentSlide} direction={direction} />
        </div>
        <CarouselArrowButton side="right" onClick={handleGoNext} />
      </div>
      <CarouselDots total={DUMMY_SLIDES.length} current={currentIndex} onDotClick={handleDotClick} />
    </div>
  )
}

export default FeatureCarousel
